export default function ({commit}, {field, value}) {
    let data = {};
    switch (field){
        case 'Contragent':
            data = {
                ContragentId: value.value,
                ContragentName: value.label,
                ContragentSearchTypeId: value.type,
            };
            break;
        default:
            data[field] = value;
    }
    commit('filter_set', data);
}
